import { FC, useState } from 'react';

import { DropdownListProps } from './DropdownList.types';
import { DropdownListStyled } from './DropdownList.styles';

import DropdownListItem from './DropdownListItem';

const Dropdown: FC<DropdownListProps> = (props: DropdownListProps) => {
  const [itemSelected, setItemSelected] = useState<number>();
  const { testId, items, css, selectable, onSelect, width, focusItem, onMouseMove } = props;

  const handleClickItem = (index: number): void => {
    onSelect(items[index], index);

    if (selectable === true) {
      setItemSelected(index);
    }
  };

  const isItemSelected = (index: number): boolean => itemSelected === index;

  return (
    <DropdownListStyled css={{ ...css, width }} onMouseMove={onMouseMove}>
      {items.map((item, index) => (
        <DropdownListItem
          testId={testId ?? 'dropdown-item'}
          key={index}
          isFakeFocus={focusItem === index}
          item={item}
          onClick={() => handleClickItem(index)}
          selected={isItemSelected(index)}
          selectableMode={selectable}
        />
      ))}
    </DropdownListStyled>
  );
};

Dropdown.defaultProps = {
  disabled: false,
  selectable: false,
};

export default Dropdown;
